import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { 
    Modal,
    Form,
    Select,
    Input,
    // Tag,
    Row,
    Col,
    Card
} from 'antd';

// Constant
import { REDUX as REDUX_CONSTANT } from '../../../../../../constants'

// Components

// Handler

// Services
import { REDUX } from '../../../../../../services/util'

// Redux Action
import * as REDUX_ACTION from '../../../../../../services/redux/actions'
import PrimaryButton from '../../../../../../components/Decoration/Button/PrimaryButton';

const FormItem = Form.Item

const {
    REDUX_CRUD_API_ACTION
} = REDUX_CONSTANT

// const {
//     VAM_LINE_TYPE_BY_CODE,
//     VAM_LINE_TYPE_COLOR_BY_CODE
// } = TEMPLATE.VAM

export const VAMLineItemCUModal = ({ action, open, onClose }) => {

    const [form] = Form.useForm();

    const dispatch = useDispatch()

    const vamLines = useSelector(REDUX.reduxStoreWrapper('vamLines.itemByID'))
    const vamlid = useSelector(REDUX.reduxStoreWrapper('vamLines.selectedVAMLID'))
    const vamlineTemplates = useSelector(REDUX.reduxStoreWrapper('vamLines.templateByID'))
    const vamLineTypes = useSelector(REDUX.reduxStoreWrapper('vamLines.typeByVAMLTYIDs'))
    const uid = useSelector(REDUX.reduxStoreWrapper('user.uid'))

    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading'))

    // const [ formData, setFormData ] = useState({})
    const [ addType, setAddType ] = useState(false)

    const ModelONClose = () => {
        form.resetFields()
        onClose()
    }

    const onSubmit = async() => {
        const values = await form.validateFields();
        const v = JSON.parse(JSON.stringify(values))

        const vamltid = Object.keys(vamlineTemplates).find(k => vamlineTemplates[k].default)

        if(REDUX_CRUD_API_ACTION[action] === REDUX_CRUD_API_ACTION.UPDATE) {
            v.vamlid = vamlid
        }

        v.vamltid = vamltid || Object.keys(vamlineTemplates)[0]

        dispatch(REDUX_ACTION.v3_vamLines.cu_vam_line_request(v, REDUX_CRUD_API_ACTION[action], () => {
            ModelONClose()
        }))

    }

    // const onFormValChange = (e) => {

    //     setFormData({
    //         ...formData,
    //         ...e
    //     })
    // }

    // useEffect(() => {

    //     if(vamlid) {

    //         const vamLine = vamLines[vamlid]

    //         const {
    //             name,
    //             type
    //         } = vamLine

    //         setFormData({
    //             name,
    //             type
    //         })

    //     } else {
    //         setFormData({ type: [{}] })
    //     }

    // }, [vamlid])

    const lineType = useRef(null)

    const createNewLineTypeHDLR = () => {
        const name = lineType.current.input.value

        dispatch(REDUX_ACTION.v3_vamLines.create_vam_line_type_by_uid_request(name, uid, () => {
            lineType.current = null
        }))
    }

    useEffect(() => {
        if (vamlid) {

            const { 
                name, 
                type
            } = vamLines[vamlid]

            form.setFieldsValue({ name, type })
        } else {
            form.setFieldsValue({ }) 
        }
    }, [vamlid])


    return (
        <Modal
            title={`${action} Line Item`}
            centered
            open={open}
            okText={action}
            onOk={() => onSubmit()}
            onCancel={() => ModelONClose()}
            width={'90vw'}
            confirmLoading={loading.action}
        >
            <Form
                form={form}
                layout="vertical"
                wrapperCol={{ span: 22 }}
                // onValuesChange={(e) => onFormValChange(e)}
                // fields={[
                //     {
                //         name: ['name'],
                //         value: formData?.name
                //     },
                //     {
                //         name: ['type'],
                //         value: formData?.type
                //     }
                // ]}
            >
                <FormItem label="Line Name" name="name" rules={[{ required: true, message: 'Please input Line Item name!' }]}>
                    <Input />
                </FormItem>

                <Row>
                    <Col span={20}>
                        <FormItem label="Line Type" name="type" rules={[{ required: true, message: 'Please choose available line type!' }]}>
                            <Select 
                                showSearch
                                optionFilterProp="label"
                                disabled={loading.vamLine}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={Object.values(vamLineTypes)?.map(vlty => ({ label: vlty.name, value: vlty.vamltyid }))}
                                // tagRender={({label, value}) => {
                                //     return (
                                //         <Tag color={VAM_LINE_TYPE_COLOR_BY_CODE[value]}>{label}</Tag>
                                //     )
                                // }}
                            />  
                        </FormItem>
                    </Col>
                    <Col span={4}>
                        <PrimaryButton style={{ position: 'absolute', top: '32%' }} onClick={() => setAddType(!addType)}>+ New Type</PrimaryButton>
                    </Col>
                </Row>

                {
                    addType
                    &&
                    <Card style={{ width: '92%'}}>
                        <FormItem label={'Create New Type Line'}>
                            <Row gutter={10}>
                                <Col span={20}>
                                    <Input ref={lineType} style={{ width: '100%' }} />
                                </Col>
                                <Col span={4}>
                                    <PrimaryButton loading={loading.vamLine} onClick={createNewLineTypeHDLR}>Add Type</PrimaryButton>
                                </Col>
                            </Row>
                        </FormItem>
                    </Card>

                }
            </Form>

        </Modal>
    )
}